import * as React from 'react';
import { Field } from 'redux-form';
import { PortalFieldLabel } from 'components/FormControls';
import { IRadioButtonOption } from 'models/common/radiobuttonoption';

interface IRadioButtonsProps {
	label?: string;
	name: string;
	options: IRadioButtonOption[];
	className?: string;
}

export const PortalRadioButtons = (props: IRadioButtonsProps) => {
	const options = props.options.map((option: IRadioButtonOption) => {
		return (
			<div className="option" key={option.label}>
				<label>
					<Field name={props.name} id={option.id || option.value} component="input" type="radio" value={option.value} />
					<PortalFieldLabel name={option.value} text={option.label} tag="div" />
				</label>
				{option.optionBody}
			</div>
		);
	});

	return (
		<div className={`portalRadioButtons ${props.className ? props.className : ''}`}>
			{props.label && <PortalFieldLabel name={props.name} text={props.label} />}
			<div className="options">{options}</div>
		</div>
	);
};
